<div class="explore-loading-item">
  <span class="small-loading-cycle"></span>
  Loading...
</div>
